import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { BuildingRealEstateType } from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const getBuildingDescriptionLabel = (
	t: TranslateFunction,
	type: BuildingRealEstateType,
) => t(Resources.Portfolio.AddRealEstate.Fields.description[type]);
